export const enum FacetTypes {
	Text = "TEXT",
	Number = "NUMBER",
	Range = "RANGE",
}
